<template>
    <main-content-wrapper v-if="!authenticated">
        <template v-if="application_type == 'HN' || application_type == 'SPD'">
            <h1>
                Prijavite se
                <span class="subtitle">Imate Tuš Klub račun? Prijavite se lahko z istimi podatki.</span>
            </h1>
            <v-alert
                    :value="invalid_username_password"
                    type="error"
            >
                {{ invalid_username_password_message }}
            </v-alert>
            <v-alert
                type="warning"
                :value="loginNeeded"
            >
              Za nadaljevanje se je potrebno prijaviti.
            </v-alert>
            <v-form v-model="valid" @submit.prevent="" ref="form">
                <email-field v-model="email" label="Vaš email naslov" v-on:keypress.enter="login" autofocus />
                <password-field v-model="password" label="Geslo" v-on:keypress.enter="login" required />
                <router-link to="/pozabljeno-geslo">Ste pozabili svoje geslo</router-link>
                <empty-space />
            </v-form>
            <v-btn depressed large block color="primary_action" @click="login" :loading="loading">PRIJAVA</v-btn>
            <empty-space />
            <split-content text="Ali se prijavite z"/>
            <social-login :redirect="redirect" />
            <split-content text="Še niste član Hitrega Nakupa?" v-if="application_type=='HN' "/>
            <split-content text="Še niste član Spletne drogerije?" v-if="application_type=='SPD' "/>
            <empty-space />
            <v-btn @click="goToCreateAccount()" depressed large block>USTVARITE RAČUN</v-btn>
            <empty-space />
        </template>
        <template v-else>
            <h1>Prijava v Tuš klub profil</h1>
            <v-alert
                    :value="invalid_username_password"
                    type="error"
            >
                {{ invalid_username_password_message }}
            </v-alert>
            <v-alert
                type="warning"
                :value="loginNeeded"
            >
              Za nadaljevanje se je potrebno prijaviti.
            </v-alert>
            <v-form v-model="valid" @submit.prevent="" ref="form">
                <username-field v-model="email" v-on:keypress.enter="login" autofocus></username-field>
                <password-field v-model="password" label="Geslo" v-on:keypress.enter="login" required />
                <router-link to="/pozabljeno-geslo">Ste pozabili svoje geslo</router-link>
                <empty-space />
            </v-form>
            <v-btn depressed large block color="primary_action" @click="login" :loading="loading">PRIJAVA</v-btn>
            <empty-space />
            <split-content text="Ali se prijavite z"/>
            <social-login :redirect="redirect" />
            <split-content text="Še nimate Tuš klub računa?"/>
            <empty-space />
            <v-btn @click="goToCreateAccount()" depressed large block>USTVARITE TUŠ KLUB RAČUN</v-btn>
            <empty-space />
        </template>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import SocialLogin from "../components/SocialLogin";
    import PasswordField from "../components/PasswordField";
    import EmailField from "../components/EmailField";
    import InputField from "../components/InputField";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";
    import Router from '../router';
    import UsernameField from "../components/UsernameField";

    export default {
        name: "Login.vue",
        components: {
            UsernameField,
            MainContentWrapper, PasswordField, SocialLogin, SplitContent, InputField, EmptySpace, EmailField},
        data: vm => ({
            valid: false,
            email: null,
            password: null,
            loginNeeded: false,
        }),
        computed: {
            authenticated: utils.vuexBuildSetGet(this, 'auth', 'authenticated'),
            loading: utils.vuexBuildSetGet(this, 'auth', 'loading'),
            invalid_username_password: utils.vuexBuildSetGet(this, 'auth', 'invalid_username_password'),
            invalid_username_password_message: utils.vuexBuildSetGet(this, 'auth', 'invalid_username_password_message'),
            application_type: utils.vuexBuildSetGet(this, 'application', 'application_type'),
            redirect() {
              return this.$route.query.redirect;
            }
        },
        mounted() {
            this.$trackPageVisit('login');
            if (this.redirect) {
              this.loginNeeded = true;
            }
        },
        methods: {
            goToCreateAccount(){
                if (this.$store.state.application.allow_join_club){
                    Router.push('ustvari/izbira');
                } else {
                    Router.push('/ustvari/')
                }
            },
            login(){
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.$store.dispatch('auth/login', {username: this.email, password: this.password, redirect: this.redirect});
                }
            }
        }
    }
</script>

<style scoped>

</style>